/* lua.js generated code undefined */

let Base = unpack(require("clover/logic/userTagData/UserTagBase"))[0]
let Tag = xClass("SingleLevelHardnessTag", Base)
Tag.prototype.init = function () {
    let self = this
    self.record = table()
    self.config = table()
    UserLevel.getInstance().on(UserLevelEvent.ExitLevel, handler(self, self.logEndLevel))
    UserLevel.getInstance().on(UserLevelEvent.LoseLevel, handler(self, self.logEndLevel))
}
Tag.prototype.logEndLevel = function (event) {
    let self = this
    let topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    let levelType = LevelType.getLevelTypeByLevelId(event.levelId)
    let score = UserScore.getInstance().getScore(event.levelId)
    if (levelType === GameLevelType.kMainLevel && score.star < 1 && event.levelId === topLevel && (event.costMove || 0) > 5) {
        if (self.record[event.levelId]) {
            self.record[event.levelId] = self.record[event.levelId] + 1
        } else {
            self.record[event.levelId] = 1
            let topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
            let record = table()
            for (let k in self.record) {
                let v = self.record[k]
                if ($null(v)) continue
                if (k >= topLevel - 10 && k <= topLevel) {
                    record[k] = v
                }
            }
            self.record = record
        }
        self.needStoreData()
    }
}
Tag.prototype.convertOnlineRecord = function (data) {
    let self = this
    let ret = table()
    for (let i = 1, v = data.levelFails[1]; v; i++, v = data.levelFails[i]) {
        ret[v.first] = v.second
    }
    return table([1, "record", ret])
}
Tag.prototype.refresh = function (data) {
    let self = this
    if (data.record) {
        self.record = table()
        for (let k in data.record) {
            let v = data.record[k]
            if ($null(v)) continue
            self.record[tonumber(k) || 0] = tonumber(v) || 0
        }
    }
    if (data.config) {
        self.config = table()
        for (let k in data.config) {
            let v = data.config[k]
            if ($null(v)) continue
            self.config[tonumber(k) || 0] = table([1, "min", tonumber(v.min) || 0], [1, "max", tonumber(v.max) || 0])
        }
    }
}
Tag.prototype.getTag = function () {
    let self = this
    let topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    let hardness = MetaManager.getInstance().getLevelHardness(topLevel)
    if (hardness !== 0) {
        let record = self.record[topLevel] || 0
        for (let k in self.config) {
            let v = self.config[k]
            if ($null(v)) continue
            if (record >= hardness * v.min / 100 && record < hardness * v.max / 100) {
                return k
            }
        }
    }
    return 0
}
Tag.prototype.encode = function () {
    let self = this
    let data = table()
    data.record = self.record
    data.config = self.config
    return data
}
module.exports = Tag
